import styled, { css } from 'styled-components';

export const LabelWrapper = styled.div`
  color: #000000;
  font-size: 1em;
  text-align: ${props => props.textAlignment};
  display: ${props => (props.block ? 'block' : 'inline')};
  font-family: ${props => (props.font ? props.theme.fontSets[props.font] : props.isTitleNarrowMedium ? `${props.theme.fontSets.narrowBold}` : `${props.theme.fontSets.narrowRegular}`)};
  align-self: ${props => (props.alignSelf ? `${props.alignSelf}` : 'center')};
  line-height: ${props => (props.lineHeight ? `${props.lineHeight}` : 1)};
  text-transform: ${props => (props.isCapitalize ? 'uppercase' : 'normal')};
  width: ${props => props.width};
  ${props => props.color && css`
    color: ${props.theme.colors[props.color]};
  `};
  ${props => props.letterSpacing && css`
    letter-spacing: ${props.letterSpacing};
  `};
  ${props => props.size && css`
  font-size: ${props.size}em;
  `};
  ${props => props.weight && css`
    font-weight: ${props.weight};
  `};
  ${props => props.margin && css`
    margin: ${props.margin}
  `};
   ::selection{
    background: none;
  }
`;

export const PreLabelContainer = styled.span`
  font-family: ${props => (props.theme.fontSets.narrowMedium)};
  font-weight: bold;
`;



// WEBPACK FOOTER //
// ./src/components/shared/Label/styles.js